import _extends from "@babel/runtime/helpers/esm/extends";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
// Classes
import Metrics from "./Metrics.js"; // Types
// Constants
export const COUNTER_TYPE = 'metrics.counter';
export const COUNTER_VERSION = '1.0.0';
var _value = /*#__PURE__*/_classPrivateFieldLooseKey("value");
/**
 * A counter is a cumulative metric that represents a single increasing counter whose value can only increase or be reset to zero.
 * Do not use a counter to expose a value that can decrease.
 * See https://deezer.jira.com/l/c/1Y101sJ2 for more information.
 */
export default class CounterMetrics extends Metrics {
  constructor(options) {
    var _options$value;
    super(options);
    Object.defineProperty(this, _value, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _value)[_value] = (_options$value = options.value) != null ? _options$value : 0;
  }
  increment(by = 1) {
    if (by <= 0) {
      throw new Error('Counter value can only increase');
    }
    _classPrivateFieldLooseBase(this, _value)[_value] += by;
  }
  reset() {
    _classPrivateFieldLooseBase(this, _value)[_value] = 0;
  }
  serialize() {
    return _extends({}, super.serialize(), {
      counter: _classPrivateFieldLooseBase(this, _value)[_value]
    });
  }
  get value() {
    return _classPrivateFieldLooseBase(this, _value)[_value];
  }
}
//# sourceMappingURL=CounterMetrics.js.map